import React from 'react';

import logo from '../../../main/assets/images/defense/Logo-black.png';

export const Navbar = () => {
  return (
    <nav className="program-navbar">
      <div className="program-navbar-container">
        <div className="program-navbar-content">
          <div className="program-navbar-icon">
            <img
              src={logo}
              style={{ width: '64px', height: '64px', objectFit: 'contain' }}
            />
          </div>
        </div>
      </div>
    </nav>
  );
};
